var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 496C64 504.75 56.75 512 48 512H16C7.25 512 0 504.75 0 496V32C0 14.25 14.25 0 32 0S64 14.25 64 32V496ZM476.234 0C469.869 0 463.256 1.344 456.928 4.227C411.24 25.082 377.369 32.168 349.094 32.168C289.133 32.168 254.291 0.309 185.217 0.301H185.189C160.844 0.301 131.635 4.867 96 15.754V366.258C128 356.273 155.869 352.16 180.85 352.16C254.479 352.16 305.775 383.941 379.402 383.941C411.316 383.941 447.42 377.973 491.365 360.852C504.053 355.852 512 344.352 512 332.102V30.727C512 11.996 495.246 0 476.234 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.942db998c31e2001962cdd196b90c977.svg";
export { ForwardRef as ReactComponent };